import React from 'react';
import { View, StyleSheet } from 'react-native';
import PropTypes from 'prop-types';

import * as Layout from '@components/screen/Layout';
import SociollaCard from '@components/sociolla/SociollaCard';
import SociollaText from '@components/sociolla/SociollaText';
import Highcharts from '@components/chart/Highcharts';
import SalesmanMonthPicker from './SalesmanMonthPicker';
import Colors from '@global/colors';
import { isWeb } from '@global/screens';

// The API's real-date bucket labels are used as-is: the wider fourth bucket explains itself.
const SalesmanVisitTrendChart = ({
  buckets,
  period,
  loading,
  error,
  onChangePeriod,
  style,
}) => {
  const body = () => {
    if (loading) {
      return <Layout.Loader />;
    }
    if (error) {
      return (
        <SociollaText style={styles.unavailable}>Unavailable</SociollaText>
      );
    }
    return (
      <Highcharts
        type="column"
        grouping
        height={isWeb ? 320 : 300}
        categories={buckets.map((bucket) => bucket.label)}
        data={[
          { name: 'Actual', data: buckets.map((bucket) => bucket.actual) },
          { name: 'Planned', data: buckets.map((bucket) => bucket.planned) },
        ]}
      />
    );
  };

  return (
    <SociollaCard style={[styles.card, style]}>
      <SociollaText type="medium" style={styles.title}>
        Visit Trend - Planned vs Actual
      </SociollaText>

      <SalesmanMonthPicker
        value={period}
        disabled={loading}
        onChange={onChangePeriod}
      />

      <View style={styles.chart}>{body()}</View>
    </SociollaCard>
  );
};

SalesmanVisitTrendChart.propTypes = {
  buckets: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      planned: PropTypes.number,
      actual: PropTypes.number,
    }),
  ),
  period: PropTypes.shape({
    year: PropTypes.number.isRequired,
    month: PropTypes.number.isRequired,
  }).isRequired,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  onChangePeriod: PropTypes.func.isRequired,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

SalesmanVisitTrendChart.defaultProps = {
  buckets: [],
  loading: false,
  error: false,
  style: null,
};

const styles = StyleSheet.create({
  // marginBottom 0 for the same reason as the metric cards: the screen owns the row gaps.
  card: { marginBottom: 0, padding: 16 },
  chart: { justifyContent: 'center', minHeight: isWeb ? 320 : 260 },
  title: { fontSize: 16, marginBottom: 16 },
  unavailable: { color: Colors.red0, fontSize: 16, textAlign: 'center' },
});

export default SalesmanVisitTrendChart;
